// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_LEAVES, ADD_LEAVES_ADMIN, ASSIGNEE_DROPDOWN_LIST, DELETE_LEAVES, EDIT_LEAVES, GET_LEAVES, LEAVES } from '../../../../common/constant'

export const actionLeaves = createAsyncThunk('appLeaves/actionLeaves', async (params, thunkAPI) => {
    return await post(LEAVES, params, thunkAPI)
})

export const actionAddLeaves = createAsyncThunk('appLeaves/actionAddLeaves', async (params, thunkAPI) => {
    return await put(ADD_LEAVES, params, thunkAPI)
})

export const actionAddLeavesAdmin = createAsyncThunk('appLeaves/actionAddLeavesAdmin', async (params, thunkAPI) => {
    return await put(ADD_LEAVES_ADMIN, params, thunkAPI)
})

export const actionGetLeaves = createAsyncThunk('appLeaves/actionGetLeaves', async (params, thunkAPI) => {
    return await post(GET_LEAVES, params, thunkAPI)
})

export const actionEditLeaves = createAsyncThunk('appLeaves/actionEditLeaves', async (params, thunkAPI) => {
    return await post(EDIT_LEAVES, params, thunkAPI)
})

export const actionDeleteLeaves = createAsyncThunk('appLeaves/actionDeleteLeaves', async (params, thunkAPI) => {
    return await post(DELETE_LEAVES, params, thunkAPI)
})

export const actionAssigneeToDropdown = createAsyncThunk('appLeaves/actionAssigneeToDropdown', async (params, thunkAPI) => {
    return await post(ASSIGNEE_DROPDOWN_LIST, params, thunkAPI)
})

export const appLeavesSlice = createSlice({
    name: 'appLeaves',
    initialState: {
        //list
        loading: false,
        leaves: null,

        //add
        loadingAdd: false,
        addLeaves: null,

        //add admin
        loadingAddAdmin: false,
        addLeavesAdmin: null,

        //get
        loadingGet: false,
        getLeaves: null,

        //edit
        loadingEdit: false,
        editLeaves: null,

        //delete
        loadingDelete: false,
        deleteLeaves: null,

        //assginee to dropdown
        loadingAssigneeToDropdown: false,
        assigneeToDropdown: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetLeavesResponse: (state) => {
            state.leaves = null
        },
        resetAddLeavesResponse: (state) => {
            state.addLeaves = null
        },
        resetAddLeavesAdminResponse: (state) => {
            state.addLeavesAdmin = null
        },
        resetGetLeavesResponse: (state) => {
            state.getLeaves = null
        },
        resetEditLeavesResponse: (state) => {
            state.editLeaves = null
        },
        resetDeleteLeavesResponse: (state) => {
            state.deleteLeaves = null
        },
        resetAssigneeToDropdownListResponse: (state) => {
            state.assigneeToDropdown = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionLeaves.pending, (state) => {
                state.loading = true
            })
            .addCase(actionLeaves.fulfilled, (state, action) => {
                state.loading = false
                state.leaves = action.payload
            })
            .addCase(actionLeaves.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddLeaves.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddLeaves.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addLeaves = action.payload
            })
            .addCase(actionAddLeaves.rejected, (state) => {
                state.loadingAdd = false
            })

            //Admin
            //add
            .addCase(actionAddLeavesAdmin.pending, (state) => {
                state.loadingAddAdmin = true
            })
            .addCase(actionAddLeavesAdmin.fulfilled, (state, action) => {
                state.loadingAddAdmin = false
                state.addLeavesAdmin = action.payload
            })
            .addCase(actionAddLeavesAdmin.rejected, (state) => {
                state.loadingAddAdmin = false
            })

            //get
            .addCase(actionGetLeaves.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetLeaves.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getLeaves = action.payload
            })
            .addCase(actionGetLeaves.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditLeaves.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditLeaves.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editLeaves = action.payload
            })
            .addCase(actionEditLeaves.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteLeaves.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteLeaves.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteLeaves = action.payload
            })
            .addCase(actionDeleteLeaves.rejected, (state) => {
                state.loadingDelete = false
            })

            //assignee to dropdown
            .addCase(actionAssigneeToDropdown.pending, (state) => {
                state.loadingAssigneeToDropdown = true
            })
            .addCase(actionAssigneeToDropdown.fulfilled, (state, action) => {
                state.loadingAssigneeToDropdown = false
                state.assigneeToDropdown = action.payload
            })
            .addCase(actionAssigneeToDropdown.rejected, (state) => {
                state.loadingAssigneeToDropdown = false
            })
    }
})
export const { resetLeavesResponse, resetAddLeavesResponse, resetAddLeavesAdminResponse, resetGetLeavesResponse, resetEditLeavesResponse, resetDeleteLeavesResponse, resetAssigneeToDropdownListResponse } = appLeavesSlice.actions

export default appLeavesSlice.reducer